import React from 'react';
import { useToasterStore } from '../stores/ui/toasterStore';

interface CopyButtonProps {
  text: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  title?: string;
  onCopy?: () => void;
}

const CopyButton: React.FC<CopyButtonProps> = ({ 
  text, 
  size = 'sm', 
  className = '',
  title = '주소 복사',
  onCopy
}) => {
  const { showToaster } = useToasterStore();
  const sizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation(); // 부모 요소의 클릭 이벤트 전파 방지
    try {
      await navigator.clipboard.writeText(text);
      // 복사 성공 시 콜백 호출
      if (onCopy) {
        onCopy();
      } else {
        // 기본 토스트 메시지 표시
        showToaster('Copied to clipboard!', 'success');
      }
    } catch (error) {
      console.error('클립보드 복사 실패:', error);
      showToaster('Failed to copy to clipboard.', 'error');
    }
  };

  return (
    <button
      onClick={handleCopy}
      className={`text-gray-500 hover:text-white transition-colors cursor-pointer ${className}`}
      title={title}
      style={{
        marginTop: 3
      }}
    >
      <svg 
        className={sizeClasses[size]} 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" 
        />
      </svg>
    </button>
  );
};

export default CopyButton;
